import {useEffect, useState} from 'react';

export const useWindowFocusListener = (handler: () => void) => {
  const [windowHasFocus, setWindowHasFocus] = useState(true);
  useEffect(() => {
    setWindowHasFocus(document.hasFocus());

    const focusListener = () => {
      setWindowHasFocus(true);
      handler();
    };
    const blurListener = () => setWindowHasFocus(false);
    window.addEventListener('focus', focusListener);
    window.addEventListener('blur', blurListener);
    return () => {
      window.removeEventListener('focus', focusListener);
      window.removeEventListener('blur', blurListener);
    };
  }, [handler]);
  return windowHasFocus;
};
